module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2c"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('em', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm01"
    }
  }, [_c('em', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm02"
    }
  }, [_c('em', [_vm._v("Abbreviations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm03"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01"
    }
  }, [_vm._v("The Island Division")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_l"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec1"
    }
  }, [_vm._v("Beatons in Portree")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_l"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec2"
    }
  }, [_vm._v("Beatons of Ballenabe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_l"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec3"
    }
  }, [_vm._v("Beatons in North Uist")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_l"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec4"
    }
  }, [_vm._v("Beatons of Connista")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_l"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec5"
    }
  }, [_vm._v("Beatons in Sleat")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_l"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec6"
    }
  }, [_vm._v("Beatons of Pennycross")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_l"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec7"
    }
  }, [_vm._v("Beatons in South Uist")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_l"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec8"
    }
  }, [_vm._v("Beatons in Kintail")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_l"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec9"
    }
  }, [_vm._v("Beatons of Kilelane")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_l"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec10"
    }
  }, [_vm._v("Beatons in Colonsay")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_l"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec11"
    }
  }, [_vm._v("Beatons in Dervaig")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mainland Division")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_l"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beatons of Balgillachie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_l"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beatons of Kildavanan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_l"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beatons of Melness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_l"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beatons of Husabost")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_l"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beatons of Culnaskea")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_l"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beatons in Delny")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Beaton Medical Families")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_l"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beatons in Kinloid etc.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_l"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beatons in Glenconvinth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Status and Landholding")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Medicine and Medical Men")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Schools and Manuscripts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Demise of the Classical Tradition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/bm01",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Appendices")])])]), _vm._v(" "), _c('table', {
    staticClass: "tab_tb"
  }, [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "toch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beaton Medical Families and Distribution Map")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beaton Physicians c.1300–c.1750")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Signatures, Handwriting and Ownership of Manuscripts")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gaelic Manuscripts associated with Beatons")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ó Conchobhair Physicians in Lorn")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MacPhails in Muckairn")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm07",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ac427ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0